export default __webpack_public_path__ + "static/fitmee_2-c88d46d8958b3b5d7a7a7fd03d4a9c01.png";